module.exports = __webpack_public_path__ + "static/orientacion-ux-399d0b260629da7ab85817a6d4ba8068.svg";